import styled from 'styled-components'

export const Bg = styled.div`
  min-height: 100vh;
  height: 100vh;
  width: 100%;
`

export const MainLayout = styled.div`
  float: right;
  display: flex;
  flex-direction: column;
  width: 80%;
  background-color: white;
`

export const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 0;
  overflow-y: auto;
  min-height: 100vh;
`
